<template>
  <div>
    <!--     資料顯示的layer     -->
    <div id="showtable">
      <template v-for="(sportObj, sportObjKey) in sportList" v-if="selectedBettype.sprtId == 'G98'  || (selectedBettype.sprtId == sportObj.sprtId && selectedBettype.sprtId !='G98' ) ">
        <div class="list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card" v-if="checkValue(sportObj.sprtId,otrSportList) == 'true'" @click='showSportMatches(sportObjKey)' data-v-477f976d="" style="height: 38px !important; width: 100% !important;" :style="(!showFavEvents && selectedBettype.tmpltId==11)?' top: 85.5px;':' top: 39.5px;'">
            <div data-v-4c1e5c89="" class="list-card-inner">
              <div data-v-40c999f5="" data-v-4c1e5c89="" class="match-type text-left yb-flex-between">
                <div data-v-40c999f5="" class="col-left">
                  {{ getSportLang(sportObj.sprtId) }}
              </div>
            </div>
          </div>
        </div>
          <!-- hide -->
        <template v-if="!sportList[sportObjKey].hide">
          <template v-for="(eventObj, eventObjKey) in eventList" >
            <template v-if="eventObj && eventObj != 'undefined' && (!showFavEvents || otrFavorite(eventObj.eveid, 'N'+eventObj.sptid, favouriteOTREventsList) ) && sportObj.sprtId=='N'+eventObj.sptid">
              <template v-if="typeof eventObj == 'object' && eventObj.t && Object.keys(eventObj.t).length > 1">
                <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important; "  :style="(!showFavEvents && selectedBettype.tmpltId==11)?' top: 115.5px;':' top: 39.5px;'">
                  <div class="list-card-inner">
                    <div class="c-match-league" :class="{ 'leagues-pack': eventList[eventObjKey].hide }" >
                      <div class="tr-match-headotr">
                        <div class="leagues-wrap">
                          <i size="14px" class="icon-arrow q-icon c-icon" @click="showLeg(eventObjKey, false)"></i>
                          <div class="league-icon-wrap" @click="showLeg(eventObjKey, false)">
                            <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/16/5E/CgURtWKi4z2Aea3eAAATUrdoWBo688.png" style="opacity: 1;"> -->
                          </div>
                          <div class="ellipsis-wrap" @click="showLeg(eventObjKey, false)">
                            <div class="absolute-full">
                              <span class="ellipsis allow-user-select" :title="eventObj.lgecapt">
                                {{ eventObj.lgecapt }} - {{ eventObj.evecapt }}
                              </span>
                            </div>
                          </div>
                          <div class="icon-wrap">
                            <i class="icon-star q-icon c-icon"
                              :class="{ active: otrFavorite(eventObj.eveid, 'N'+eventObj.sptid, favouriteOTREventsList) }"  @click="favouriteOtr(eventObj.eveid,'N'+eventObj.sptid,$event)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-if="!eventList[eventObjKey].hide">
                  <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'evet' + eventObj.eveid">
                    <!-- style="height: 108px !important; width: 760px !important;"> -->
                    <div class="list-card-inner">
                      <div class="c-match-card relative-position evecard" style="">
                        <!-- style="height: 108px !important; width: 760px !important;"> -->
                        <div class="c-match-item m-otr tpl-18 csid-1">
                          <div class="play-wrap">
                            <div class="play-info vrow items-center yb-flex-between">
                              <div class="ellipsis max1">{{ eventObj.evecapt }}</div>
                              <div>
                                <template v-if="selectedLang == 2 || selectedLang == 3">
                                 <!-- {{ moment(matchDateCheck(eventObj.evedt)).locale('cn').format("LL HH:mm") }}-->
                                  {{ matchDateCheck(eventObj.evedt) | date('YYYY年MM月DD日 HH:mm') }}
                                </template>
                                <template v-else>
                                  {{ matchDateCheck(eventObj.evedt) | date('DD/MM/YYYY HH:mm') }}
                                </template>
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_6.CUTOFFDATE'] }}
                              </div>
                            </div>

                            <template v-for="(Team, TeamKey) in eventObj.t" v-if="TeamKey % 2 != 0">
                              <!-- <template v-if="TeamKey % 2 != 0"> -->
                              <div class="bet-list-wrap vrow">
                                <div class="bet-col" style="height: 35px !important;">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                    <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text">{{ Team.tcapt }}</div>
                                    </div>
                                    <template v-if="Team.od">
                                      <oddOutright :event="eventObj" :team="TeamKey"></oddOutright>
                                    </template>
                                  </div>
                                </div>

                                <div class="bet-col" style="height: 35px !important;">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                    <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text">
                                        <template v-if="eventObj.t[parseInt(TeamKey) + 1]">
                                          {{ eventObj.t[parseInt(TeamKey) + 1].tcapt }}
                                        </template>
                                      </div>
                                    </div>
                                    <template
                                      v-if="eventObj.t[parseInt(TeamKey) + 1] && eventObj.t[parseInt(TeamKey) + 1].od">
                                      <oddOutright :event="eventObj" :team="parseInt(TeamKey) + 1"></oddOutright>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </template> <!-- END eventObj.t -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </template>
          </template>
        </template>
        <!--END eventList -->
      </template> 
      <!--END sportlist -->
      <div class="" v-if="(eventList && Object.keys(eventList).length > 0)">
        <div style="height: 15px;"></div>
        <div class="pager-wrap vrow justify-end">
          <div class="go-top-btn yb-flex-center" @click="backtoTop">
            <i aria-hidden="true" role="presentation" class="q-icon icon-go_top c-icon" style="font-size: 14px;"></i>
            <div class="vmsg">{{ lang.sportAllBet['ALL_BET.BACK_TOP'] }}</div>
          </div>
        </div>
      </div>
      <div class="absolute-full resize-observer-wrap">
        <div class="absolute-full expand"></div>
        <div class="absolute-full shrink"></div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import moment from 'moment'
import 'moment/locale/zh-cn'
import EventBus from '../../events/event-bus'
import filterDate from '@/vue/filters/date'
import OddOutrightComponents from '../../components/odd-outright'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [sportFavourite],
  components: {
  },
  computed: {
    ...mapGetters([
      'eventList',
      'sportTableLang',
      'selectedBettype',
      'favouriteOTREvents',
      'sportList',
      'otrSportList',
      'timeZone',
      'showLgeEve',
      // 'sports_arr'
    ]),
    favouriteOTREventsList: {
      get() {
        return this.$store.getters.favouriteOTREvents;
      }
    },
    showFavEvents: {
      get() {
        return this.$store.getters.showFavEvents
      },
    },
  },
  watch: {
    favouriteOTREventsList: {
      handler(val, oldVal) {
        // console.log('favouriteOTREventsListVal :'+val)
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      lang: window.lang,
      showhideAll: true,
      moment: moment,
      selectedLang: window._langid,
    }
  },
  methods: {
    matchDateCheck(date){
    return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
    },
    checkValue(value,arr){
      var status = 'false';
    
      for(var i=0; i<arr.length; i++){
        var name = arr[i];
        if('N'+name == value){
          status = 'true';
          break;
        }
      }

      return status;
    },
    showEvent(sptid, eveid,eve){
      if(this.$store.getters.showFavEvents){
        return this.otrFavorite(eveid, sptid, eve)
      }else{
        return true
      }
    },
    getTop(){
      // var topVal = (this.selectedMarket == this.$store.getters.market.tdyMarket.key  && this.$store.getters.selectedBettype.betTypId != 5) ? '73.5' : '89.5'
      var topVal =  '73.5' 
      return 'top:'+topVal+'px'
    },
    showLeg(key) {
      this.$set(this.eventList[key], 'hide', !this.eventList[key].hide)
    },
    showSportMatches(key) {
      this.$set(this.sportList[key], 'hide', !this.sportList[key].hide)
    },
    
    getSportLang(sptId){
      var vue = this
      var capt = ''
      _.forEach(vue.sportList, function (sportdata, key) {
        if(sptId == sportdata.sprtId){
          capt = sportdata.sprtLang
        }
        return capt
      })

      return capt
    },
    backtoTop() {
      // $(".list-scrollbar").animate({ scrollTop: 0 },100);
      $(".sport-table-scroll").animate({ scrollTop: 0 },100);
    },
  },
  updated() {
    $('#showtable').children().closest('.evecardwrap').each(function () {
      var a = jQuery(this).find(".evecard").height()
      jQuery(this).find(".evecard").height(a)
      jQuery(this).height(a + 5)
    });
  },
  mounted() {

  },
}
</script>
<style lang="scss">
.b_tab {
  .team-info {
    height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/sportOutright.vue